import { render, staticRenderFns } from "./OverallAssessmentPage.vue?vue&type=template&id=79ee4754"
import script from "./OverallAssessmentPage.vue?vue&type=script&lang=ts"
export * from "./OverallAssessmentPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports